import React from "react";
import CircularProgress from '@material-ui/core/CircularProgress';

const _decodeUrl = (url) => {
    let outPut = url;
    outPut = outPut.replace(/%3A/g, ":");
    outPut = outPut.replace(/%2F/g, "/");
    outPut = outPut.replace(/%3F/g, "?");
    outPut = outPut.replace(/%26/g, "&");
    outPut = outPut.replace(/%3D/g, "=");
    outPut = outPut.replace(/%20/g, " ");

    return outPut;
}

const _encodeUrl = (url) => {
    let outPut = url;
    outPut = outPut.replace(/:/g, "%3A");
    outPut = outPut.replace(/\//g, "%2F");
    outPut = outPut.replace(/\?/g, "%3F");
    outPut = outPut.replace(/&/g, "%26");
    outPut = outPut.replace(/=/g, "%3D");
    outPut = outPut.replace(/ /g, "%20");

    return outPut;
}

const QRCode = props => {

    if (props.metadata == undefined || props.metadata.title == undefined) {
        return (
            <div style={{ marginTop: "15%", marginBottom: "15%", textAlign: "center" }}>
                A Soundtrail name is needed before a QR code can be generated.
                <br />
                Click on the Soundtrail Data tab to add a name.
            </div>
        )
    } else if (
        props.markerLayer == undefined ||
        props.markerLayer.feature == undefined ||
        props.markerLayer.feature.properties == undefined ||
        props.markerLayer.feature.properties.hotspotId == undefined
    ) {
        // this should never happen, but just incase
        return (
            <div style={{ marginTop: "15%", marginBottom: "15%", textAlign: "center" }}>
                An ID is needed before a qr code can be generated.
                <br />
                Please ensure all hotspot information is filled before attempting to generate a QR code.
            </div>
        )
    }

    const defaultUrl = "https%3A%2F%2Fwww.soundtrails.com.au%2Fsoundtrails%2F" +
        props.metadata.title.toLowerCase() +
        "%3Fhs%3D" +
        props.markerLayer.feature.properties.hotspotId +
        "%26fromQR%3Dtrue"

    const [url, setUrl] = React.useState(defaultUrl);
    const [loading, setLoading] = React.useState(true);
    const qrServer = "https://api.qrserver.com/v1/create-qr-code/?size=200x200&data="

    let imgStyle = { margin: "20px 170px" }
    if (loading) {
        imgStyle.height = "0px"
    }

    return (
        <div>
            {loading ? <div style={{ margin: "100px 0px 60px 240px" }}><CircularProgress /></div> : <div />}
            <img style={imgStyle} src={qrServer + url} onLoad={() => setLoading(false)}></img>
            <input style={{ width: "500px", margin: "10px" }} onChange={(event) => { setUrl(_encodeUrl(event.target.value)); setLoading(true); }} defaultValue={_decodeUrl(url)} className="prettyInput"></input>
        </div>
    )
}

export default QRCode;